import React from "react";
import { TableHead, TableRow } from "@material-ui/core";
import { StyledTableCell } from "components/profiles/ProfileStyles";
import TableSortLabel from "@material-ui/core/TableSortLabel";

export default function CustomTableHead({
  attributes,
  order,
  orderBy,
  handleRequestSort,
}) {
  return (
    <TableHead>
      <TableRow>
        {attributes.map((attribute, index) => (
          <StyledTableCell
            key={index}
            size="small"
            align="left"
            sortDirection={orderBy === index ? order : false}
          >
            <TableSortLabel
              active={orderBy === index}
              direction={order}
              onClick={() => handleRequestSort(index)}
            >
              {attribute.columnText.toUpperCase()}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
